export default "__VITE_ASSET__BRwwjCvX__"